'use client';
import { Loader2 } from 'lucide-react';
import { Button, ButtonProps } from '~/components';
import { cn } from '~/style';

export function SubmitButton({
  label,
  isLoading,
  className,
  variant,
}: {
  label?: string;
  isLoading: boolean;
  className?: string;
  variant?: ButtonProps['variant'];
}) {
  return (
    <Button
      type="submit"
      className={cn('w-full', className)}
      size="md"
      disabled={isLoading}
      variant={variant}
    >
      {isLoading ? (
        <Loader2 className="h-6 w-6 animate-spin" />
      ) : (
        label || 'Save'
      )}
    </Button>
  );
}
